import React from 'react';
import { connect } from 'react-redux';
import userManager from '../../utils/userManager';

import AvatarHeader from '../../components/common/avatarHeader';

const signOutHandler = () => {
  userManager.removeUser();
};

const Header = ({ user }) => (
  <AvatarHeader user={user} signOut={signOutHandler} />
);

const mapStateToProps = ({ oidc }) => ({
  user: oidc.user,
});

export default connect(mapStateToProps)(Header);
